import { Plugin, Context } from '@nuxt/types';
import Pusher from 'pusher-js';
import { createPusher } from '../lib/pusher';

function handlePusherData(context: any, data: any) {
  context.store.commit(`${data.store}/${data.mutation}`, data.payload, {
    root: true
  });
}

function listen(context) {
  const pusher = createPusher(
    context.store.state.user.id,
    context.store.state.user.clientId
  );

  pusher.userChannel.bind('data', data => {
    handlePusherData(context, data);
  });
  pusher.clientChannel.bind('data', data => {
    handlePusherData(context, data);
  });
  pusher.globalChannel.bind('data', data => {
    handlePusherData(context, data);
  });
}

const pushToStateListener: Plugin = (context: Context, inject) => {
  inject('pushToStateListener', {
    listen: () => listen(context)
  });
};
export default pushToStateListener;
